import NudgesContainer from "@/app/components/ui/Nudges/NudgesContainer";
import CircleSpinnerLoader from "@/app/components/ui/Reusable/LoaderComponent/CircleSpinnerLoader";
import { useState } from "react";

interface FinishEMRModalProps {
  isOpen: boolean;
  loader: boolean;
  onClose: () => void;
  onSubmit: () => void;
  activeEMRId: string;
  alert_category_list: any[];
}

const FinishEMRModal = ({
  isOpen,
  onClose,
  onSubmit,
  activeEMRId,
  alert_category_list,
  loader,
}: FinishEMRModalProps) => {
  const [nudgeData, setNudgeData] = useState(null);



  if (!isOpen) return null;


  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-lg max-w-[600px] p-5">
        <h2 className="text-base font-semibold mb-3">Finish EMR</h2>

        <div className="text-xs text-gray-700 leading-5">
          Are you sure you want to submit the EMR? This will mark the EMR as{" "}
          <strong className="text-green-600">Completed</strong> from <strong className="text-yellow-600">Draft</strong>{" "}
          state. It cannot be edited later.
        </div>

        <div className="py-3">
          <NudgesContainer source="EMR" ermid={activeEMRId} alert_category_list={alert_category_list} setNudgeData={setNudgeData} />
        </div>

        <div className="flex justify-end gap-3 mt-4">
          <button
            onClick={onClose}
            className="border border-gray-300 bg-white px-4 py-2 rounded-lg text-sm font-medium"
          >
            {nudgeData?.cta_1 ? nudgeData?.cta_1 : "Cancel"}
          </button>
          <button
            onClick={onSubmit}
            className={`bg-black text-white px-5 py-2 rounded-lg text-sm font-medium  ${loader && "cursor-not-allowed"}`}
          >
            {loader ? <CircleSpinnerLoader h="20" w="90" /> : "Submit EMR"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FinishEMRModal;
